import { encode, decode } from 'js-base64'

export const base64Decode = (string) => decode(string)
export const base64Encode = (string) => encode(string)
